let priorOverflow: string | null = null;

export function lockBodyScroll(): void {
  if (priorOverflow !== null) return;
  priorOverflow = document.body.style.overflow;
  document.body.style.overflow = 'hidden';
}

export function unlockBodyScroll(): void {
  if (priorOverflow === null) return;
  document.body.style.overflow = priorOverflow;
  priorOverflow = null;
}

export function isBodyScrollLocked(): boolean {
  return priorOverflow !== null;
}

/** @internal test helper */
export function resetScrollLockState(): void {
  priorOverflow = null;
}
